<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  create(){
    let locale = this.$route.query.lang||localStorage.getItem('language')||'zh-cn';
    this.$i18n.locale=locale;//改变当前语言
    localStorage.setItem('language',locale);
  },
  watch:{
    '$route':function(to,from){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
}
</script>

<style lang="scss">
*{
  padding: 0;
  margin: 0;
  border: 0;
}
body {
  font-family: 'PingFangSC-Regular', sans-serif, "microsoft yahei", "微软雅黑", "Helvetica Neue", Helvetica, sans-serif, Helvetica-Bold;
}
input{ outline:none;}
li{ list-style:none;}
img{ border:0 none; vertical-align:top;}
em,i,b{ font-style:normal;}
a{ text-decoration:none;}
[v-cloak] {
    display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue